<template>
    <div>
         <div class="about-banner">
            <img src="../../static/img/about.png" />
            <div class="about-banner-word">
                <span>关于我们 About Us</span>
                <img src="img/fb.png" />
            </div>
        </div>
        <div class="news-change-title">
            <a href="javascript:;" v-for="(item,index) in menu_active" @click="changeTab(index)" class="news-change-item" :class="{selected:item.isActive}" :key="index">{{item.title}}</a>
        </div>
        <!-- 新聞中心 -->
        <div class="tab-card">
            <div class="news-change-content">
                <div class="news-change-list"  v-for="(ever,index) in new_work.data" :key="index">
                    <img :src="baseUrl+ever.cover" />
                    <div class="news-change-list-content">
                        <h4>{{ever.title}}</h4>
                        <div>
                            <span>{{ever.addtime}}</span>
                            <a @click="toDetail(ever.new_id)">了解详情</a>
                        </div>
                    </div>
                </div>
            </div>
            <a class="loading-more" @click="clickGetMore">{{loadingText}}</a>   
        </div>
        <div class="tab-card" style="display:none;">
            <!-- 通告 -->
            <div class="news-change-content">
                <div class="news-list" v-for="(ever,index) in new_li.data" :key="index">
                    <a href="javascript:;" @click="toDetail(ever.new_id)">
                        <h3>{{ever.title}}</h3>
                        <span>{{ever.addtime}}</span>
                    </a>
                </div>
            </div>
            <a class="loading-more" @click="clickGetMore2">{{loadingText2}}</a>   
        </div>
        
        
    </div>
</template>

<script>
export default {
    name:'newsList',
    data(){
        return {
            menu_active: [
                {
                    title: '工作动态',
                    link: '',
                    isActive: true,
                },
                {
                    title: '通知公告',
                    link: '',
                    isActive: false,
                },
            ],
            active: false,
            loadingText:"加载中...",
            loadingText2:"加载中...",
            model1: {
                //工作动态
                type: 1,
                page: 1, //当前页数
            },
            new_work: '',
            model3: {
                //通知公告
                type: 3,
                page: 1, //当前页数
            },
            new_li: '',
        }
    },
    mounted(){
        this.baseUrl = window.baseUrl;
        this.config = window.config;
        this.moreNews();
        this.inform();
    },
    methods:{
        //切換
        changeTab: function(tabIndex){
            var that = this;
            var tabCardCollection = document.querySelectorAll(".tab-card"),
            len = tabCardCollection.length;
            for(var i = 0; i < len; i++) {
                tabCardCollection[i].style.display = "none";
                that.menu_active[i].isActive = false;
            }
            that.menu_active[tabIndex].isActive = true;
            tabCardCollection[tabIndex].style.display = "block";
        },
        NewsCurrentChange: function(val){
            this.model1.page = val;
            this.moreNews();
        },
        moreNews: function(){
            var that = this;
            that.loadingText="加载中..."
            that.$http.post(that.baseUrl+that.config.moreNews,that.$qs.stringify(that.model1)).then(function(ev){
                if(ev.data.code == 100){
                    that.new_work = ev.data.data;
                    if(ev.data.data.length>0){
                        that.loadingText="点击加载更多"
                    }else{
                        that.loadingText="已加载全部"
                    }
                    
                }
            }).catch(function(error){
                console.log(error);
            })
        },
        clickGetMore:function(){
            var that=this;
            that.model1.page++;
             that.loadingText="加载中..."
            that.$http.post(that.baseUrl+that.config.moreNews,that.$qs.stringify(that.model1)).then(function(ev){
                if(ev.data.code==100){
                    that.new_work=that.new_work.concat(ev.data.data);
                     that.loadingText="点击加载更多"
                }else if(ev.data.code==200){
                    that.loadingText="已加载全部"
                }
            }).catch(function(error){
                console.log(error)
            });
        },
        clickGetMore2:function(){
            var that=this;
            that.model3.page++;
            that.loadingText2="加载中...";
            that.$http.post(that.baseUrl+that.config.moreNews,that.$qs.stringify(that.model3)).then(function(ev){
                if(ev.data.code==100){
                    that.new_li=that.new_li.concat(ev.data.data);
                    that.loadingText2="点击加载更多"
                }else if(ev.data.code==200){
                    that.loadingText2="已加载全部"
                }
                console.log(ev.data.code);
            }).catch(function(error){
                console.log(error)
            });
        },
        inform: function(){
            // console.log('123')
            var that = this;
            that.loadingText2="加载中..."
            that.$http.post(that.baseUrl+that.config.moreNews,that.$qs.stringify(that.model3)).then(function(ev){
                // console.log(ev);
                if(ev.data.code == 100){
                    that.loadingText2="点击加载更多"
                    that.new_li = ev.data.data;
                }else if(ev.data.code == 200){
                    that.loadingText2="已加载完毕"                    
                }
            }).catch(function(error){
                console.log(error);
            })
        },
        NewsCurrentChange1: function(val){
            this.model3.page = val;
            this.inform();
        },
        toDetail: function(new_id){
            console.log(new_id);
            this.$router.push({
                // name: 'newsContent',
                name: 'Detail',
                params: {
                    new_id: new_id
                }
            })
        }
    },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/newsList.vue